<template>
  <b-container fluid class="animated fadeIn">
      
  </b-container>
</template>

<script>

export default {
  name : 'ListarSerie'
};
</script>

<style>
</style>
